module.exports = __webpack_public_path__ + "static/media/devops.15fc682c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/devops.jpg
// module id = 48
// module chunks = 0